<template>
  <b-card no-body>
    <b-table
      ref="table"
      class="bg-white"
      responsive
      show-empty
      :fields="fields"
      :items="items"
    >
      <template #empty>
        <p align="center">
          <span v-if="!busy">{{ trans('none') }}</span>
          <span v-if="busy">
            <i class="fa fa-fw fa-circle-notch fa-spin" v-if="busy"></i>
            {{ trans('please_wait') }}
          </span>
        </p>
      </template>
      <template #cell(tags)="data">
        <tags
          :organization="organization"
          :model="data.item"
          type="student"
          :label="trans('skill')"
          :placeholder="trans('skills')"
          hide-button-label
          hide-edit
        ></tags>
      </template>
    </b-table>
  </b-card>
</template>

<script>
  import Tags from './../tag/Tags'

  export default {
    props: {
      organization: Object,
      client: Object,
    },
    components: {
      Tags,
    },
    data() {
      return {
        trans: trans,
        moment: moment,
        busy: false,
        error: null,
        fields: [
          {
            key: 'name',
            label: trans('name'),
          },
          /*{
            key: 'email',
            label: trans('email'),
            sortable: true,
          },*/
          {key: 'tags', label: trans('skills')},
        ],
        items: null,
      }
    },
    methods: {
      fetch() {
        this.busy = true
        this.error = null
        let url = `/org/${this.organization.id}/client/students_with_skills`
        return axios.get(url)
        .then(response => {
          this.busy = false
          this.items = response.data
        })
        .catch(error => {
          this.busy = false
          this.error = _.errorFromAjax(error)
          this.$bvToast.toast(this.error, {
            title: trans('error'),
            variant: 'danger',
            solid: true,
          })
          this.items = []
        })
      },
    },
    mounted() {
      window.myDocuments = this
      this.fetch()
    },
  }
</script>